/** @jsx jsx */
import React from "react";
import Accordion from "components/molecules/Accordion";
import DataTable from "components/organismos/DataTable/DataTable";
import { css, jsx } from "@emotion/core";
import ApprovedTransferDomain from "../domain/approvedTransferDomain";
import { useApplyingTransferForm } from "../ApplyingTab/hook";
import IconLabelButton from "components/molecules/IconLabelButton";
import Modal from "components/molecules/Modal";
import ChangeLogModal from "components/molecules/ChangeLogModal";
import TextTooltip from "components/molecules/TextTooltip";

const TransferAccordion: React.FC<{ list: ApprovedTransferDomain[] }> = ({
  list,
}) => {
  const {
    changeLogData,
    setChangeLogData,
    changeLogModalOpen,
    setChangeLogModalOpen,
    setSelectChangelog,
    fetchChangeLogTransfer,
  } = useApplyingTransferForm(list);

  const columns = React.useMemo(
    () => [
      {
        Header: "承認日時",
        accessor: "approvalDate",
      },
      {
        Header: "組織名",
        accessor: "orgName",
      },
      {
        Header: "申請者",
        accessor: "applicant",
        Cell: (cell: { row: { isExpanded: boolean; original: any } }) => (
          <div style={{ textAlign: "left" }}>
            {cell.row.original.staffCode}<br></br>{cell.row.original.staffName}
          </div>
        )
      },
      {
        Header: "申請日時",
        accessor: "applicationDate",
      },
      {
        Header: "申請\n種別",
        accessor: "modifiyStatusName",
      },
      {
        Header: "対象者",
        accessor: "targetPerson",
        Cell: (cell: { row: { isExpanded: boolean; original: any } }) => (
          <div style={{ textAlign: "left" }}>
            {cell.row.original.staffCode}<br></br>{cell.row.original.staffName}
          </div>
        )
      },
      {
        Header: (any: any) => "対象日付",
        id: "",
        accessor: "targetDate",
        Cell: (cell: {
          row: { isExpanded: boolean; original: any; index: number };
          data: any;
        }) => {
          return (
            <div style={{ textAlign: "center" }}>
              <div>
                <div>{cell.row.original.targetDate}</div>
                <IconLabelButton
                  onClick={() => {
                    fetchChangeLogTransfer(cell.row.original.rawData);
                    setChangeLogModalOpen(true);
                    setSelectChangelog("0");
                  }}
                  text="更新履歴"
                  textAlign="center"
                  isIcon={false}
                />
              </div>
            </div>
          );
        },
      },
      {
        Header: "振替休日",
        accessor: "transferHolidayDate",
      },
      {
        Header: "申請理由",
        accessor: "applicationReason",
        Cell: (cell: {row: { isExpanded: boolean; original: any }})=>(
          <TextTooltip text={cell.row.original?.applicationReason} textDis={(
            <div className="ellipsis headline-cell-width-150"
              style={{
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                width: '150px'
              }}>
                {cell.row.original?.applicationReason}
            </div>
          )} />  
        )
      },
    ],
    [fetchChangeLogTransfer, setChangeLogModalOpen, setSelectChangelog]
  );

  return (
    <React.Fragment>
    <div
      css={css`
      table {
        table-layout: auto;
      }
      table th:nth-of-type(1) {
        width: 80px;
      }
      table tbody tr td:nth-of-type(1) {
        text-align: center;
      }
      table th:nth-of-type(2) {
        width: 120px;
      }
      table th:nth-of-type(3) {
        width: 120px;
      }
      table td:nth-of-type(3) {
        white-space: pre-line;
      }
      table th:nth-of-type(4) {
        width: 80px;
      }
      table tbody tr td:nth-of-type(4) {
        text-align: center;
      }
      table th:nth-of-type(5) {
        width: 50px;
        white-space: pre;
      }
      table th:nth-of-type(5) span{
        display:block;
        margin: auto;
      }
      table th:nth-of-type(5) span svg {
        margin-left: 0!important;
      }
      table th:nth-of-type(6) {
        width: 120px;
      }
      table td:nth-of-type(6) {
        white-space: pre-line;
      }
      table th:nth-of-type(7) {
        width: 80px;
      }
      table th:nth-of-type(8) {
        width: 80px;
      }
      table th:nth-of-type(9) {
        width: 120px;
      }
      `}
    >
      <Accordion
        text={`振替申請 (${list.length}件）`}
        callBack={() => {}}
      >
        <div style={{ overflowX: 'auto', whiteSpace: 'nowrap', padding:'0 10px 10px' }}>
          <DataTable columns={columns}classNameParrant="border-left-right border-bottom" className="table-no-border-left-right" data={list} isGlobalFilter={true} minWidth="100%" sortBy={[{id : 'approvalDate', desc: true}]} />
        </div>
      </Accordion>
    </div>
    {/* Change log  */}
    <div css={css('>div>div{ width: 1000px }')}>
      <Modal
        closeHandler={() => {
          setChangeLogModalOpen(false);
          setChangeLogData([]);
        }}
        open={changeLogModalOpen}
        title="更新履歴"
        submitText="閉じる"
        onSubmit={() => {
          setChangeLogModalOpen(false);
          setChangeLogData([]);
        }}
        closeText=""
        > 
          <ChangeLogModal changeLogData={changeLogData} request='振替申請'/>
        </Modal>
      </div>
      {/* ./Change log  */}
    </React.Fragment>
  );
};

export default TransferAccordion;
